import { ItpDto } from 'data/generated/graphql';

export const formatRequestBody = (issue: ItpDto, currentProperty: string | null) => ({
  itpDTOSaveInput: {
    itpDTO: issue
  },
  publicationKey: currentProperty ?? 'wsj'
});
